export default __webpack_public_path__ + "static/media/wave.fce35f00.svg";